import styled from "styled-components";
import { EditTournamentInputBox } from "../../base/style";

export const EditTournamentParticipationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .top {
    display: flex;
    gap: 10px;
    align-items: center;

    > .name {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 20px;
    }
  }
`;

export const EditTournamentParticipationContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
  column-gap: 40px;
`;

export const EditTournamentParticipationSettingBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 20px;
`;

export const EditTournamentParticipationInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 20px 15px;
  box-sizing: border-box;
  width: max-content;
`;

export const EditTournamentParticipationInputBox = styled(
  EditTournamentInputBox
)`
  gap: 10px;

  > .name {
    width: 92px;
    font-weight: 600;
    font-size: 15px;
  }

  > input {
    height: 28px;
    text-align: right;
    padding-right: 22px;
    box-sizing: border-box;
  }

  > span {
    top: 8px;
  }
`;
